// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRaven from 'vue-raven'
import App from './App'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import store from './store'
import IdleVue from 'idle-vue'
import VeeValidate from 'vee-validate'
import VuePaginate from 'vue-paginate'
import VueAnalytics from 'vue-analytics'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'

Vue.use(VueRaven, {
  dsn: 'https://0799abdeb32542f993779ce6e056f172@sentry.io/1207370',
  dev: process.env.NODE_ENV !== 'production'
})

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))
Vue.use(VuePaginate)

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-117997582-1',
  router,
  autoTracking: {
    exception: true
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

const validateConfig = {
  errorBagName: 'validate_errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 1500,
  locale: 'en',
  dictionary: null,
  strict: false,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
}

// Password validations
const containsAlphaLower = {
  getMessage (field, args) {
    return field[0].toUpperCase() + field.substring(1) + ' must contain a lower case letter.'
  },
  validate (value, args) {
    return (/[a-z]/.test(value))
  }
}
const containsAlphaUpper = {
  getMessage (field, args) {
    return field[0].toUpperCase() + field.substring(1) + ' must contain an upper case letter.'
  },
  validate (value, args) {
    return (/[A-Z]/.test(value))
  }
}
const containsNumber = {
  getMessage (field, args) {
    return field[0].toUpperCase() + field.substring(1) + ' must contain a number.'
  },
  validate (value, args) {
    return (/[0-9]/.test(value))
  }
}

VeeValidate.Validator.extend('contains_alpha_lower', containsAlphaLower)
VeeValidate.Validator.extend('contains_alpha_upper', containsAlphaUpper)
VeeValidate.Validator.extend('contains_number', containsNumber)
Vue.use(VeeValidate, validateConfig)

Vue.prototype.$passwordRequirements = 'The password must be at least 8 characters and contain numbers and upper and lower case letters.'

const eventsHub = new Vue()

const idleOptions = {
  eventEmitter: eventsHub,
  idleTime: 900000, // 15 minute idle
  startAtIdle: false,
  store: store
}
Vue.use(IdleVue, idleOptions)

// This needs to be moved to its own file
// Better yet, the repo owner ought to release an npm package of this
// https://github.com/h2akim/vue-pretty-print-bytes-filter/pull/1
Vue.filter('prettyBytes', function (num, precision) {
  // jacked from: https://github.com/h2akim/vue-pretty-print-bytes-filter
  num = Number(num)
  if (isNaN(num)) {
    throw new TypeError('Expected a number')
  }
  if (isNaN(precision) || (precision === undefined || precision == null)) {
    precision = 3
  }

  var neg = num < 0
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  if (neg) {
    num = -num
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B'
  }

  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
  num = (num / Math.pow(1000, exponent)).toPrecision(precision) * 1
  var unit = units[exponent]

  return (neg ? '-' : '') + num + ' ' + unit
})

let tenant = 'smart'

/**
 * This determines whether the tenant is SMART or msb based on the host domain
 * It runs before any page loads
 *
 * Presumably, the two domains will be something like
 * msbfileportal.smartpaymentplan.com
 * fileportal.smartpaymentplan.com
 *
 * We would then split into parts and look for the part that equals 'com'
 * and then branch on the part before that.
 *
 * The Vuex store is updated with the tenant
 * Additional tenant information is in the mutations.js file
 * Ideally, we'd have a better organization to centralize tenant changes
 */
router.beforeEach((to, from, next) => {
  let parts = window.location.host.split(':')
  parts = parts[0].split('.')
  let subdomain = parts[0]
  if (subdomain === 'localhost') {
    // tenant = 'msb'
  }
  if (subdomain === 'msbfileportal') {
    tenant = 'msb'
  }
  store.commit('updateTenant', tenant)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store === undefined) {
      router.push({ name: 'Login' })
    } else if (!store.getters.cognitoAuthenticated) {
      router.push({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  data: {
    tenant: tenant
  },
  router,
  store,
  template: '<App/>',
  components: { App }
})

window.Vue = app
export default app



// WEBPACK FOOTER //
// ./src/main.js